<template>
    <div class="b_botton" 
        :class="{disable: disable}"
        @click="click()"
    >   
        <slot>
        </slot>
        <transition name="loading">
            <div class="loading"
                v-if="!flag"
            >
                <div class="load_wrap">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        disable: Boolean,
        call: Function
    },
    data() {
        return {
            flag: true,
            timer: 0
        }
    },
    methods: {
        ready() {
            clearTimeout(this.timer);
            this.flag = true;
        },
        start () {
            var length = this.call.length;
            if (length > 0) this.timer = setTimeout(_=>{
                this.flag = false;
            },150);
        },
        click(e) {

            if (this.flag&&this.call) {
                !this.disable && this.call({
                    start: this.start,
                    ready: this.ready
                });
            }
        } 
    }
}
</script>

<style scoped>

.b_botton {
    background: #263264;
    border: 1px solid #414695;
    border-top: 1px solid #565FBD;

    font-size: 13px;
    color: #a5a8c5;
    cursor: default;

    height: 30px;
    line-height: 30px;
    position: relative;
    display: inline-block;
    transition: background .08s;
    border-radius: 2px;
    user-select: none;

    display: flex;
    align-items: center;
    justify-content:center;
}

.b_botton.disable,
.b_botton.disable:hover,
.b_botton.disable:active  {
    color: #4D4F6D;
    background: #263264;
}

.b_botton:hover{
    color: #dee2f0;
    background: #2d3b74;
}

.b_botton:active {
    background: #303f7c;
}

.content {
    display: flex;
    align-items: center;
}

.loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(190, 218, 255, .08);
}

.load_wrap {
    display: flex;
    flex: 0 1 auto;
    justify-content: space-between;
    align-items: center;
    width: 28px;
    height: 8px;
}

.loading span {
    display: flex;
    flex: 0 1 auto;
    width: 5px;
    height: 5px;
    background: #005FAA;
    border-radius: 50%;
}

.loading span:first-child {
    animation: item1 2s ease-in 0s infinite;
}

.loading span:nth-child(2) {
    animation: item2 2s ease-in 0s infinite;
}

.loading span:last-child {
    animation: item3 2s ease-in 0s infinite;
}

@keyframes item1 {
    0% {
        transform: translateX(0);
    }
    33.3% {
        transform: translateX(10px);
    }
    66.6% {
        transform: translateX(24px);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes item2 {
    0% {
        transform: translateX(0);
    }
    33.3% {
        transform: translateX(10px);
    }
    66.6% {
        transform: translateX(-10px);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes item3 {
    0% {
        transform: translateX(0);
    }
    33.3% {
        transform: translateX(-24px);
    }
    66.6% {
        transform: translateX(-10px);
    }
    100% {
        transform: translateX(0);
    }
}

.loading-enter-active {
    transition: opacity .08s;
}

.loading-leave-active {
    transition: opacity .08s;
}
  
.loading-enter, .loading-leave-to {
    opacity: 0;
}

</style>
